<template>
    <div class="main">
        <el-form label-position="top">
            <el-row :gutter="10" class="u-mb-10">
                <el-col :xs="24" :sm="4" :md="4">
                    <el-form-item label="Período de Visualização" prop="periodo" key="periodo">
                        <el-select size="small" v-model="filtro.periodo" @change="changeFiltros" clearable>
                            <el-option :key="7" label="Últimos 7 dias" :value="7"></el-option>
                            <el-option :key="15" label="Últimos 15 dias" :value="15"></el-option>
                            <el-option :key="30" label="Últimos 30 dias" :value="30"></el-option>
                            <el-option :key="90" label="Últimos 90 dias" :value="90"></el-option>
                            <el-option :key="0" label="Total" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="10" :md="10" v-if="([4, 5, 6, 7, 8, 10, 11].includes(Number($store.state.user.tipo)))">
                    <el-form-item label="Instituição" key="instituicao">
                        <el-select @change="changeFiltros" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                            <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>                
            </el-row>
        </el-form>
        <div class="container-table u-mt-10">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Nome do Aluno</th>
                        <th class="u-text-center">Total de Faltas</th>
                    </tr>
                </thead>
                <tbody v-if="statusList">
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ item.aluno_nome }}</td>
                        <td class="u-text-center">{{ item.faltas || 0 }}</td>
                    </tr>
                </tbody>
            </table>
            <div v-if="!statusList" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>
            <div v-if="statusList && filtro.instituicao.id && items.length === 0" style="border: 1px solid #ccc; background-color: #efefef;">
                <h4 class="u-text-center">Nenhum registro encontrado</h4>
            </div>
            <div v-if="statusList && !filtro.instituicao.id && items.length === 0" style="border: 1px solid #ccc; background-color: #efefef;">
                <h4 class="u-text-center">Selecione uma instituição</h4>
            </div>
            <el-row :gutter="10" v-if="statusList">
                <el-col :xs="24" :sm="12" :md="12">
                    <div class="u-text-left u-mt-10">
                        Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
                    <div class="u-text-right">
                        <el-pagination :current-page='paginate.page' class="u-mt-10" :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>

export default {
    data: () => ({
        statusList: false,
        filtro: {
            instituicao: {},
            periodo: 7, // 0 = total, 7, 15, 30, 90 = dias
        },
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        items: []
    }),
    mounted () {
        this.filtro.periodo = 0; // Inicializa com Total

        if(this.$store.state.config.instituicao){
            this.filtro.instituicao = this.$store.state.config.instituicao;
        }

        this.loadingFaltas()
    },
    methods: {
        async changeFiltros(){

            if([4,5,6,7,8,11].includes(Number(this.$store.state.user.tipo))){
                await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id);
            }

            this.paginate.page = 1;
            this.loadingFaltas();
        },
        loadingFaltas(){

            if(!this.filtro.instituicao.id){
                this.statusList = true;
                this.items = [];
                return false;
            }

            this.statusList = false;
            this.items = [];

            let periodo = this.filtro.periodo || 0;
            let instituicao_id = this.filtro.instituicao.id;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/diario/getDashboardFaltas/${periodo}/${instituicao_id}?page=` + this.paginate.page, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data || [];
                this.paginate.qtdItens = response.data.total;
                this.paginate.from = response.data.from;
                this.paginate.to = response.data.to;
                this.statusList = true;

            }).catch((error) => { 
                this.statusList = true;
                this.$store.commit('throwException', error); 
            });

        },
        getPagePagination(page){
            this.paginate.page = page;
            this.loadingFaltas();
        }
    },
    components:{  }
}
</script>
